import { connect } from 'react-redux';
import {
  isInstructor,
  currentClassRoomId,
} from '../../../../../core/selectors/classroom';
import { goToClassPresentation } from '../../../../actions/navigation';
import LiveSessionIndicator from './LiveSessionIndicator';

const mapStateToProps = (state) => {
  return {
    spaceId: currentClassRoomId(state),
    isEducator: isInstructor(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  goToClassPresentation: (spaceId, presentationId, correlationId) => {
    dispatch(goToClassPresentation(spaceId, presentationId, correlationId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveSessionIndicator);
